import { render, staticRenderFns } from "./KvAvatar.vue?vue&type=template&id=06577eac&"
import script from "./KvAvatar.vue?vue&type=script&lang=js&"
export * from "./KvAvatar.vue?vue&type=script&lang=js&"
import style0 from "./KvAvatar.vue?vue&type=style&index=0&id=06577eac&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06577eac')) {
      api.createRecord('06577eac', component.options)
    } else {
      api.reload('06577eac', component.options)
    }
    module.hot.accept("./KvAvatar.vue?vue&type=template&id=06577eac&", function () {
      api.rerender('06577eac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/kiva/KvAvatar.vue"
export default component.exports